import React from 'react'
import styles from './style.module.scss'
import { useAppSelector } from '~/shared/hooks/redux'
import Link from 'next/link'
import { FaBars, FaUserTie } from "react-icons/fa6";
import { useTranslation } from 'next-i18next';
import LanguageSwitcher from '~/shared/components/LanguageSwitcher';
import { Dropdown } from 'antd';
import { ThemeToggle } from '~/shared/components/theme-toggle';

const HomeNavbar = () => {
    const themeMode = useAppSelector(state => state?.theme?.mode)
    const user = useAppSelector(state => state?.auth?.user)
    const { t } = useTranslation('common');

    const navLinks = [
        { href: '#types', label: t('nav.income_ways') },
        { href: '#steps', label: t('nav.how_it_works') },
        { href: '#bests', label: t('nav.top_sellers') },
        { href: '/legal/oferta', label: t('nav.user_guide') },
        { href: '/page/video-list', label: t('nav.manual') },
    ];

    const mobileMenuItems = [
        ...navLinks.map((item) => ({
            key: item.href,
            label: (
                <Link href={item.href}>
                    <a className={styles.menuLink}>{item.label}</a>
                </Link>
            ),
        })),
        { type: 'divider' as const },
        ...(user?.access
            ? [
                {
                    key: 'profile',
                    label: (
                        <Link
                            href={
                                user?.role === 'seller' ? '/seller/dashboard' :
                                    (user?.role === 'admin' && user?.is_superuser)
                                        ? '/admin/dashboard'
                                        : '/admin/sellers'
                            }>
                            <a className={styles.dropdown_sign_up_btn}>
                                {t('nav.go_to_profile')}
                            </a>
                        </Link>
                    ),
                },
            ]
            : [
                {
                    key: 'login',
                    label: (
                        <Link href={'/auth/login'}>
                            <a className={styles.dropdown_login_btn}>
                                {t('nav.login')}
                            </a>
                        </Link>
                    ),
                },
                {
                    key: 'register',
                    label: (
                        <Link href={'/auth/register'}>
                            <a className={styles.dropdown_sign_up_btn}>
                                <FaUserTie />{' '}
                                {t('nav.become_seller')}
                            </a>
                        </Link>
                    ),
                },
            ]),
    ];
    // soff_logo_white.webp ./static/img/seller-logo.jpg
    return (
        <div className={styles.navbar}>
            <div className='container' style={{ maxWidth: "1400px" }}>
                <div className={`${styles.navbar_innner} py-4`}>
                    <div className={styles.navbar_logo}>
                        <img
                            src={themeMode === 'dark' ? '/static/img/soff-logos/soff_logo_white.webp' : './static/img/seller-logo.jpg'}
                            alt="soff seller logo"
                        />
                    </div>
                    <ul className={styles.navbar_items}>
                        {navLinks.map((item) => (
                            <li key={item.href}>
                                <Link href={item.href}>
                                    <a>{item.label}</a>
                                </Link>
                            </li>
                        ))}
                    </ul>
                    <nav className={styles.navbar_btns}>
                        <LanguageSwitcher />
                        <ThemeToggle />
                        <Dropdown
                            menu={{ items: mobileMenuItems }}
                            placement="bottomRight"
                            trigger={['click']}
                        >
                            <button
                                type="button"
                                className={styles.mobileMenuBtn}
                                aria-label="Open menu"
                            >
                                <FaBars />
                            </button>
                        </Dropdown>
                        {user?.access ? (
                            <Link
                                href={
                                    user?.role === 'seller' ? '/seller/dashboard' :
                                        (user?.role === 'admin' && user?.is_superuser)
                                            ? '/admin/dashboard'
                                            : '/admin/sellers'
                                }>
                                <a
                                    className={styles.sign_up_btn}
                                    aria-label={
                                        'register or become a seller'
                                    }>
                                    {t('nav.go_to_profile')}
                                </a>
                            </Link>
                        ) : (
                            <>
                                <Link href={'/auth/login'}>
                                    <a
                                        className={styles.login_btn}
                                        aria-label="sign in">
                                        {t('nav.login')}
                                    </a>
                                </Link>
                                <Link href={'/auth/register'}>
                                    <a
                                        className={styles.sign_up_btn}
                                        aria-label={
                                            'register or become a seller'
                                        }>
                                        <FaUserTie />{' '}
                                        {t('nav.become_seller')}
                                    </a>
                                </Link>
                            </>
                        )}
                    </nav>
                </div>
            </div>
        </div>
    )
}

export default HomeNavbar
